export default {
  SearchPlaceholder: '搜索加速ip/域名',
  ClientName: '客户名称',
  AcceleratedIP: '加速IP',
  SpeedUpDomainName: '加速域名',
}